import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase/firebase-config';
import { resolveFirebaseAuthError } from '../platform/authErrorMessages';

const PASSWORD_RESET_PATH = '/select-organization';

export function getPasswordResetContinueUrl() {
  if (typeof window === 'undefined') {
    return PASSWORD_RESET_PATH;
  }
  return `${window.location.origin}${PASSWORD_RESET_PATH}`;
}

export const PASSWORD_RESET_SENT_MESSAGE =
  'Če račun s tem elektronskim naslovom obstaja, boste prejeli povezavo za ponastavitev gesla.';

export async function sendPasswordResetForEmail(email) {
  const normalized = String(email || '').trim();
  if (!normalized) {
    throw new Error('Vnesite elektronski naslov.');
  }

  try {
    await sendPasswordResetEmail(auth, normalized, {
      url: getPasswordResetContinueUrl(),
      handleCodeInApp: false,
    });
  } catch (error) {
    const code = error?.code || '';
    if (code === 'auth/user-not-found') {
      return;
    }
    throw new Error(resolveFirebaseAuthError(error, { context: 'passwordReset' }));
  }
}
